var _defs, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationBuildings = function SvgSimpleIllustrationBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__buildings_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".simple-illustration__buildings_svg__st0{fill:#ffa75a}.simple-illustration__buildings_svg__st0,.simple-illustration__buildings_svg__st1,.simple-illustration__buildings_svg__st2,.simple-illustration__buildings_svg__st3{stroke:#002140;stroke-linejoin:round}.simple-illustration__buildings_svg__st0,.simple-illustration__buildings_svg__st1,.simple-illustration__buildings_svg__st3{stroke-linecap:round}.simple-illustration__buildings_svg__st1{fill:#8dc8ff}.simple-illustration__buildings_svg__st2{fill:none}.simple-illustration__buildings_svg__st4{fill:#002140}.simple-illustration__buildings_svg__st3{fill:#ffd7b0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st3",
    d: "M41.5 23h21v35h-21z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 46.5,
    y: 28,
    width: 5,
    height: 7,
    rx: 0.5,
    ry: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 46.5,
    y: 38,
    width: 5,
    height: 7,
    rx: 0.5,
    ry: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 53.5,
    y: 28,
    width: 5,
    height: 7,
    rx: 0.5,
    ry: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 53.5,
    y: 38,
    width: 5,
    height: 7,
    rx: 0.5,
    ry: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st0",
    d: "M33.5 10h8v48h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st1",
    d: "M47.5 50h10v8h-10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st2",
    d: "M52.5 50v8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st3",
    d: "M13.5 10h28v48h-28z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 20.5,
    y: 15,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 20.5,
    y: 26,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 20.5,
    y: 37,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 30.5,
    y: 15,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 30.5,
    y: 26,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "simple-illustration__buildings_svg__st4",
    x: 30.5,
    y: 37,
    width: 6,
    height: 8,
    rx: 0.5,
    ry: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st0",
    d: "M5.5 10h8v48h-8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st1",
    d: "M19.5 50h18v8h-18z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__buildings_svg__st2",
    d: "M25.5 50v8M31.5 50v8"
  })));
};
export default SvgSimpleIllustrationBuildings;